import { Flex, Text } from '@chakra-ui/react';

export const DetailsList = ({ data = [], p = '16px' }) => {
  if (!data || data.length === 0) return null;

  return (
    <Flex flexDir="column" gap="8px" p={p}>
      {data.map(({ label, value }, index) => {
        return (
          <Flex key={index} flexDir="row" gap="8px">
            <Text size="sm-semi-bold" minW="fit-content">
              {label}:
            </Text>
            <Text size="sm-medium" flex="1">
              {value || '-'}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
